import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "wouter";

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (!cookieConsent) {
      // TODO: Review ESLint rule here
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
  };

  const closeBanner = () => {
    localStorage.setItem("cookieConsent", "dismissed");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-slate-900 text-white py-4 px-4 z-50 shadow-lg">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-slate-300 text-center sm:text-left">
          Este sitio utiliza cookies esenciales para su funcionamiento, análisis
          y contenido personalizado. Al continuar navegando, acepta el uso de
          cookies.{" "}
          <Link href="/politica-cookies">
            <a className="text-[#5b9bd5] hover:underline">
              Política de Cookies
            </a>
          </Link>
        </p>
        <div className="flex items-center gap-3">
          <Button
            onClick={acceptCookies}
            variant="outline"
            className="border-[#5b9bd5] text-[#5b9bd5] hover:bg-[#5b9bd5] hover:text-white text-sm"
            data-testid="button-cookie-settings"
          >
            Aceptar Cookies
          </Button>
          <button
            onClick={closeBanner}
            className="text-slate-400 hover:text-white transition-colors"
            aria-label="Cerrar"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
